import type { CSSProperties } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar'

import { classNames } from '@/utils/helpers'
import { getInitials } from '@/utils/string.ts'

interface Props {
  name: string
  avatarSrc?: string | null
  size?: number
  className?: string
  style?: CSSProperties
  fallbackClassName?: string
}

export const CreatorAvatar = ({
  name,
  avatarSrc,
  size,
  className,
  style,
  fallbackClassName,
}: Props) => {
  const initials = getInitials(name)

  return (
    <Avatar
      className={classNames(
        'bg-secondary-100 flex justify-center overflow-hidden rounded-full align-middle',
        className,
      )}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        ...style,
      }}
      title={name}
    >
      {avatarSrc && (
        <AvatarImage
          src={avatarSrc}
          alt={`${name} Avatar`}
          className="h-full w-full rounded-full object-cover"
        />
      )}
      {avatarSrc && (
        <AvatarFallback
          className={classNames(
            'bg-primary-500 text-neutral-default flex h-full w-full items-center justify-center leading-[1.7]',
            fallbackClassName,
          )}
        >
          {initials}
        </AvatarFallback>
      )}
      {!avatarSrc && (
        <div
          className={classNames(
            'bg-primary-500 text-neutral-default flex h-full w-full items-center justify-center leading-[1.7]',
            fallbackClassName,
            {
              'text-xs': (size || 0) < 32,
            },
          )}
        >
          {initials}
        </div>
      )}
    </Avatar>
  )
}
